const __DEV__ = false;

var data = { constraints:{ values:{ auto:"auto",
      scale:"100%",
      xs:"50px",
      s:"132px",
      m:"355px",
      l:"496px",
      xl:"768px" } } };

var constraints = data;

export { constraints as default };
//# sourceMappingURL=constraints.yaml.js.map
